import {
  ConfigurationStatusType,
  FcdEncodingStatusType,
  IntendedUsageType,
  VildEncodingStatusType
} from 'app/models/enums';

import { AlertcLinear } from './alertclinear.model';
import { AlertcPoint } from './alertcpoint.model';
import { Contract } from './contract.model';
import { FcdStructure } from './fcdStructure.model';
import { OpenlrStructure } from './openlrStructure.model';
import { SiterecordComment } from './siterecord-comment.model';
import { SiterecordCharacteristics } from './siterecordcharacteristics.model';
import { SiterecordIntersections } from './siterecordintersections.model';
import { ValidationError } from './validationerror.model';

export class Siterecord {
  public id: number;
  public contractId: number;
  public contract: Contract;
  public recordId: string;
  public recordName: string;
  public recordVersionNr: number;
  public recordVersionDateTime: Date;
  public locationType: string; // LocationType
  public active: boolean;
  public deleted: boolean;
  public inShapefile: boolean;
  public status: ConfigurationStatusType;
  public vildEncodingStatus: VildEncodingStatusType;
  public fcdEncodingStatus: FcdEncodingStatusType;
  public computationMethod: string; // ComputationMethodType
  public equipmentTypeUsed: string; // EquipmentType
  public equipmentReference: string;
  public numberOfLanes: number;
  public lineShapeLength: number;
  public side: string; // SideType;
  public lineShape: string[];
  public pointShape: string[];
  public previousLineShape: string[];
  public previousPointShape: string[];
  public originalLineShape: string[];
  public originalPointShape: string[];
  public routingPoints: string;
  public creationDateTime: Date;
  public mutationDateTime: Date;
  public mutationUser: string;
  public siterecordComments: SiterecordComment[];

  public previousRoutingPoints: string;
  public adminRoutingPoints: string;
  public bearing?: number;
  public previousBearing?: number;
  public adminBearing?: number;
  public intendedUsageType?: IntendedUsageType;

  public ncisExported: boolean;

  public siterecordCharacteristics?: SiterecordCharacteristics[];
  public alertcLinears?: AlertcLinear[];
  public currentAlertcLinears?: AlertcLinear[];
  public futureAlertcLinears?: AlertcLinear[];
  public alertcPoints?: AlertcPoint[];
  public currentAlertcPoints?: AlertcPoint[];
  public futureAlertcPoints?: AlertcPoint[];
  public siterecordIntersections?: SiterecordIntersections[];
  public openlrStructure?: OpenlrStructure;
  public fcdStructure?: FcdStructure;
  public validationErrors?: ValidationError[];
}



// WEBPACK FOOTER //
// ./src/app/models/siterecord.model.ts